<template>
  <div class="workgroup-table">
    <div class="table-responsive">
      <table class="table align-items-center mb-0">
        <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" style="width: 50%">
              Workgroup Name
            </th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" style="width: 25%">
              Volunteers Needed
            </th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" style="width: 15%">
              Auto Schedule
            </th>
            <th style="width: 10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td class="ps-2">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="row.name"
                placeholder="e.g. Greeters, Sound Team"
                @input="emitUpdate"
              />
            </td>
            <td class="ps-2">
              <input
                type="number"
                class="form-control form-control-sm"
                v-model.number="row.count"
                min="1"
                max="100"
                @input="emitUpdate"
              />
            </td>
            <td class="ps-2 text-center">
              <div class="form-check form-switch d-flex justify-content-center mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="row.autoSchedule"
                  @change="emitUpdate"
                />
              </div>
            </td>
            <td class="text-center">
              <button
                v-if="rows.length > 1"
                class="btn btn-link text-danger p-0 mb-0"
                @click="removeRow(index)"
                title="Remove workgroup"
              >
                <i class="material-icons" style="font-size: 20px">close</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      class="btn btn-sm btn-outline-success mt-2"
      @click="addRow"
    >
      <i class="material-icons" style="font-size: 16px; vertical-align: middle">add</i>
      Add Workgroup
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [{ name: '', count: 1, autoSchedule: true }],
  },
})

const emit = defineEmits(['update:modelValue'])

const rows = ref(
  props.modelValue.length > 0
    ? props.modelValue.map(r => ({ ...r }))
    : [{ name: '', count: 1, autoSchedule: true }]
)

// Sync from parent when modelValue changes externally (e.g. pre-population)
watch(() => props.modelValue, (newVal) => {
  if (JSON.stringify(newVal) !== JSON.stringify(rows.value)) {
    rows.value = newVal.map(r => ({ ...r }))
  }
}, { deep: true })

function addRow() {
  rows.value.push({ name: '', count: 1, autoSchedule: true })
  emitUpdate()
}

function removeRow(index) {
  rows.value.splice(index, 1)
  emitUpdate()
}

function emitUpdate() {
  emit('update:modelValue', rows.value.map(r => ({ ...r })))
}
</script>

<style scoped>
.workgroup-table .table {
  border-collapse: separate;
  border-spacing: 0;
}
.workgroup-table .table thead th {
  border-bottom: 1px solid #e9ecef;
  padding: 0.5rem;
}
.workgroup-table .table tbody td {
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  border-bottom: 1px solid #f0f2f5;
}
.workgroup-table .form-control-sm {
  font-size: 0.85rem;
  padding: 0.3rem 0.5rem;
}
.workgroup-table .form-switch .form-check-input {
  width: 2.2em;
  margin-top: 0;
}
</style>
